export default (params) => ({
  trigger: {
    name: 'content_blocks.image_entrances.view',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'two_entrances',
          'four_entrances',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
      params: {
        content: null,
      },
    },
    nonInt: true,
  },
});
